import React from 'react';
import { FolderIcon } from '@heroicons/react/24/solid';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

const FolderCard = ({ name, count, onClick }) => (
  <button
    onClick={onClick}
    className="w-full flex items-center gap-3 px-4 py-3 bg-white hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-0 text-left"
  >
    <FolderIcon className="h-6 w-6 flex-shrink-0 text-yellow-400" />
    <div className="flex-1 min-w-0">
      <p className="text-sm font-medium text-gray-800">{name}</p>
      <p className="text-xs text-gray-400">{count} {count === 1 ? 'file' : 'files'}</p>
    </div>
    <ChevronRightIcon className="h-4 w-4 text-gray-300 flex-shrink-0" />
  </button>
);

export default FolderCard;
